import { Link, makeStyles, Typography, Grid } from '@material-ui/core';
import { Email, Language, LocationOn, Phone } from '@material-ui/icons';
import React from 'react';

const useStyles = makeStyles((theme) => ({
    communication: {
        marginTop: 9,
        marginRight: 8,
        marginBottom: -9,
        color: theme.palette.primary.main,
    },
    small: {
        width: theme.spacing(33),
        height: theme.spacing(44),
    },
    smallMelas: {
        width: theme.spacing(35),
        height: theme.spacing(27),
    },
}));

export const Foreis = ({ activeDescription }: { activeDescription: number }) => {
    const classes = useStyles()

    return (
        <React.Fragment>
            {activeDescription === 1 ?
                <React.Fragment>
                    <p>
                        <Typography variant='h6'>Γενικά στοιχεία</Typography>
                        <Grid container>
                            <Grid item sm={3}>
                                <Link href='http://www.bio-hellas.gr/el/%CE%91%CF%81%CF%87%CE%B9%CE%BA%CE%AE/tabid/58/Default.aspx'> <img src="/BIOHELLAS.jpg" alt="logo" className={classes.small} /> </Link>
                            </Grid>
                            <Grid item sm={9}>
                                <Typography align={"left"}>
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    Α/Α ΦΟΡΕΑ: 2 <br />
                                    ΣΥΝΤΟΝΙΣΤΗΣ: ΟΧΙ <br />
                                    ΕΠΩΝΥΜΙΑ ΦΟΡΕΑ: ΙΝΣΤΙΤΟΥΤΟ ΕΛΕΓΧΟΥ ΒΙΟΛΟΓΙΚΩΝ ΠΡΟΙΟΝΤΩΝ Α.Ε. <br />
                                    ΣΥΝΤΟΜΟΓΡΑΦΙΑ ΦΟΡΕΑ: ΒΙΟΕΛΛΑΣ <br />
                                </Typography>
                            </Grid>
                        </Grid>
                    </p>
                    <p>
                        <Typography variant='h6'>Συνοπτική παρουσίαση δικαιούχου φορέα</Typography>
                        <Typography align='justify'>
                            O Οργανισμός Ελέγχου και Πιστοποίησης «Ινστιτούτο Ελέγχου Βιολογικών
                            Προϊόντων ΑΕ», με το διακριτό τίτλο «ΒΙΟ Ελλάς» ιδρύθηκε το 2001 και
                            λειτουργεί με τη νομική μορφή ανωνύμου εταιρείας. Η ΒΙΟ Ελλάς,
                            δραστηριοποιείται στην παροχή υπηρεσιών ελέγχου και πιστοποίησης
                            προϊόντων βιολογικής γεωργίας - κτηνοτροφίας και πιστοποίησης
                            Συστημάτων Διαχείρισης Ποιότητας. Η ΒΙΟ Ελλάς Α.Ε. αξιολογήθηκε από τον
                            Οργανισμό Πιστοποίησης και Επίβλεψης Γεωργικών Προϊόντων (AGROCERT)
                            και εγκρίθηκε από το Υπουργείο Αγροτικής Ανάπτυξης και Τροφίμων ως
                            αναγνωρισμένος Φορέας Ελέγχου και Πιστοποίησης Προϊόντων Βιολογικής
                            Γεωργίας σύμφωνα με την κοινοτική νομοθεσία που διέπει την παραγωγή
                            και εμπορία βιολογικών προϊόντων (Κανονισμοί 834/2007/ΕΚ και
                            889/2008/ΕΚ), με κωδικό έγκρισης από την Ευρωπαϊκή Ένωση GR-BIO-03. Η
                            ΒΙΟ Ελλάς, είναι διαπιστευμένος, από τον Εθνικό Συμβούλιο Διαπίστευσης
                            (Ε.ΣΥ.Δ.), Φορέας Ελέγχου και Πιστοποίησης σύμφωνα με τις απαιτήσεις των
                            προτύπων ΕΛΟΤ ΕΝ 45011:1998 και ΕΛΟΤ ΕΝ ISO/IEC 17021:2006.
                        </Typography>
                    </p>
                    <p>
                        <Typography variant='h6'>Επικοινωνία</Typography>
                        <Typography align='left'>
                            <LocationOn className={classes.communication} /> ΕΛ.ΒΕΝΙΖΕΛΟΥ 8, T.K. 55133, ΚΑΛΑΜΑΡΙΑ ΘΕΣ/ΝΙΚΗ <br />
                            <Phone className={classes.communication} /> ΤΗΛΕΦΩΝΟ ΕΠΙΚΟΙΝΩΝΙΑΣ: 2310029123 <br />
                            <Email className={classes.communication} /> <Link href='mailto:thessaloniki@bio-hellas.gr'>thessaloniki@bio-hellas.gr</Link> <br />
                            <Language className={classes.communication} /> <Link href='http://www.bio-hellas.gr/el/%CE%91%CF%81%CF%87%CE%B9%CE%BA%CE%AE/tabid/58/Default.aspx'>Ιστοσελίδα</Link>
                        </Typography>
                    </p>
                </React.Fragment>
                : null
            }

            {activeDescription === 0 ?
                <React.Fragment>
                    <p>
                        <Typography variant='h6'>Γενικά στοιχεία</Typography>
                        <Typography align='left'>
                            Α/Α ΦΟΡΕΑ: 1 <br />
                            ΣΥΝΤΟΝΙΣΤΗΣ: ΝΑΙ <br />
                            ΕΠΩΝΥΜΙΑ ΦΟΡΕΑ: ΤΜΗΜΑ ΦΑΡΜΑΚΕΥΤΙΚΗΣ, ΤΟΜΕΑΣ ΦΑΡΜΑΚΟΓΝΩΣΙΑΣ ΚΑΙ ΧΗΜΕΙΑΣ ΦΥΣΙΚΩΝ ΠΡΟΪΟΝΤΩΝ<br />
                            ΣΥΝΤΟΜΟΓΡΑΦΙΑ ΦΟΡΕΑ: ΤΦΧΦΠ <br />
                            ΕΠΩΝΥΜΙΑ ΚΥΡΙΟΥ ΦΟΡΕΑ ΣΤΟΝ ΟΠΟΙΟ ΑΝΗΚΕΙ: ΕΘΝΙΚΟ ΚΑΙ ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ / ΕΙΔΙΚΟΣ ΛΟΓΑΡΙΑΣΜΟΣ ΚΟΝΔΥΛΙΩΝ ΕΡΕΥΝΑΣ<br />
                        </Typography>
                    </p>
                    <p>
                        <Typography variant='h6'>Συνοπτική παρουσίαση δικαιούχου φορέα</Typography>
                        <Typography align='justify'>
                            Το Εθνικό και Καποδιστριακό Πανεπιστήμιο Αθηνών (ΕΚΠΑ) ιδρύθηκε
                            επίσημα το 1837. Είναι το κορυφαίο και πιο γνωστό ακαδημαϊκό ίδρυμα στην
                            Ελλάδα, προσφέροντας πολύτιμες εκπαιδευτικές υπηρεσίες. Ο Τομέας
                            Φαρμακογνωσίας και Χημείας Φυσικών Προϊόντων (ΤΦΧΦΠ) ανήκει στο
                            Τμήμα Φαρμακευτικής του Πανεπιστημίου Αθηνών και θεωρείται ένα από τα
                            πλέον σύγχρονα ερευνητικά κέντρα στον τομέα των φυσικών προϊόντων. Ο
                            ΤΦΧΦΠ εκτείνεται σε μία έκταση 2.000 τ.μ., συμπεριλαμβανομένων
                            γραφείων και εργαστηρίων. Οι κύριες ερευνητικές δραστηριότητες του
                            ΤΦΧΦΠ σχετίζονται με την ανακάλυψη νέων δραστικών φυσικών προϊόντων
                            με διάφορες εφαρμογές, όπως φαρμακευτικά προϊόντα, συμπληρώματα
                            διατροφής, καλλυντικά και αγροχημικά που βασίζονται στην Ελληνική,
                            Μεσογειακή και παγκόσμια βιοποικιλότητα. Ειδικότερα ασχολείται με α)
                            εκχύλιση και απομόνωση φυσικών προϊόντων σε εργαστηριακή και πιλοτική
                            κλίμακα, εστιάζοντας στην εφαρμογή προηγμένων τεχνικών και στη
                            βελτιστοποίηση των πρωτοκόλλων εκχύλισης/απομόνωσης, β) ανάπτυξη και
                            εφαρμογή αναλυτικών μεθόδων για τον ποιοτικό και ποσοτικό χαρακτηρισμό
                            εκχυλισμάτων, κλασμάτων και καθαρών ουσιών και στην ταυτοποίηση της
                            δομής των απομονωμένων ενώσεων και γ) αξιολόγηση βιολογικής δράσης.
                            Ωστόσο, τα τελευταία δεκαπέντε χρόνια στα κύρια Ερευνητικά ενδιαφέροντα
                            του ΤΦΧΦΠ έχει συμπεριληφθεί και η μελέτη του ελαιολάδου, με έμφαση στη

                            βιομηχανική αξιοποίησή του, στην ποιοτική του αξιολόγηση και στη μελέτη
                            της επίδρασης των βιοδραστικών του συστατικών σε χρόνια νοσήματα του
                            ανθρώπου.
                            Ο ΤΦΧΦΠ κάθε χρόνο διευρύνει τις επιστημονικές του δραστηριότητες στη
                            μελέτη του ελαιολάδου με τη συμμετοχή του ως συντονιστής ή εμπλεκόμενος
                            Φορέας σε διεθνή και εθνικά ερευνητικά προγράμματα (MediHealth, OLALA,
                            Olive-Net) και επεκτείνει τις συνεργασίες του με πανεπιστημία της Ελλάδας
                            (Τμήμα Ιατρικής-Εθνικό και Καποδιατριακό πανεπιστήμιο Αθηνών, Τμήμα
                            Βιολογίας-Εθνικό και Καποδιατριακό πανεπιστήμιο Αθηνών) και του
                            εξωτερικού (Universidad Complutense de Madrid, University of Antwerp,
                            University of Geneva, Universite d’Avignon et de Pays de Vaucluse, Ecole
                            National d’Agricalture de Meknes, University of Innsbruck), αλλά και με
                            ιδιωτικές εταιρείες και ινστιτούτα παγκοσμίου φήμης (Bruker, Bionorica,
                            Rousselet Robatel Kromaton, ADSI, Alnumed, Neuro-Sys, Natac Biotech,
                            CNRS, CNR). Συνολικά πάνω από 60 επιστημονικές εργασίες έχουν
                            δημοσιευθεί σε διακεκριμένα διεθνή επιστημονικά περιοδικά σχετικά με τη
                            μελέτη του ελαιολάδου, ενώ παράλληλα η επιστημονική παρουσία του
                            ΤΦΧΦΠ κάθε χρόνο υπογραμμίζεται με τη συμμετοχή αλλά και διοργάνωση
                            πληθώρας επιστημονικών συνεδρίων και ημερίδων. Όλα τα παραπάνω έχουν
                            οδηγήσει στη δημιουργία της ιστοσελίδας της ερευνητικής ομάδας
                            ελαιολάδου του ΤΦΧΦΠ (Olive Oil Research Group,
                            http://oliverg.pharm.uoa.gr), όπου πραγματοποιείται ανάρτηση των νέων
                            επιστημονικών επιτευμάτων και σημαντικών άρθρων επί του θέματος. Η
                            συνεισφορά και η σημασία του ΤΦΧΦΠ στα επιστημονικά τεκτενόμενα
                            επιβεβαιώνεται με τη διάχυτη παρουσία του στα μέσα μαζικής ενημέρωσης
                            μέσω συνεντεύξεων σε επιστημονικά τηλεοπτικά προγράμματα και άρθρων
                            σε εφημερίδες. Ο ΤΦΧΦΠ διαθέτει άρτια καταρτισμένο προσωπικό, ειδικούς
                            στον τομέα της φυτοχημείας ενώ διαθέτει και υπερσύγχρονα όργανα: α)
                            κλασσικά και σύγχρονα συστήματα εκχύλισης (υπερκρίσιμη εκχύλιση
                            (Supercritical Fluid Extraction), επιταχυνόμενη εκχύλιση (Accelerated
                            Solvent Extractor), εκχύλιση υποβοηθούμενη από μικροκύματα (Microwaves
                            Assisted Extraction)) β) ολοκληρωμένη σειρά μηχανημάτων και
                            μεθοδολογιών για ποιοτική και ποσοτική ανάλυση εκχυλισμάτων και
                            ενώσεων και για ταυτοποίηση δομής ουσιών (2 HPLC-UV, 2 HPLC-DAD, 1
                            HPLC-RI, 1 HPLC-ELSD, 2 GC-MS, 2 GC- FID, 2 LC-MS, 1 SFC-UV/MS, 1 UPLC-
                            MS, 1 UHPLC-HRMS, 1 UPLC-DAD/FD, 1 HPTLC, 3 NMR φασματόμετρα (200,
                            400 και 600 ΜΗz), microprobe-NMR (1 mm), HR-IT-Orbitrap (ESI, APCI και
                            APPI), 1 FT-IR, 1 συσκευή UV, 1 MPLC, 2 FCPC (αναλυτικό και
                            παρασκευαστικό)). Το εργαστήριο επίσης έχει αναπτύξει μια πιλοτική
                            μονάδα εκχύλισης, η οποία αποτελείται από 2 υπομονάδες εκχύλισης, 1x500
                            lt και 6x100 lt, 3 QVF αντιδραστήρες (10, 60 και 200 lt) και 3
                            περιστροφικούς εξατμιστήρες μεγάλης κλίμακας (rotary evaporators - 3x20
                            lt). Διαθέτει επίσης στήλες με ρητίνες προσρόφησης (ρητίνες XAD4 και XAD7

                            - 4x150 lt και 2x450 λίτρα), 1 spray dryer, 1 vacuum desiccator (100 lt),
                            αποστακτήρα αιθέριου ελαίου (100 lt) και 2 μονάδες λυοφιλοποίησης.
                        </Typography>
                    </p>
                    <p>
                        <Typography variant='h6'>Επικοινωνία</Typography>
                        <Typography align='left'>
                            <LocationOn className={classes.communication} />  Πανεπιστημιούπολη Ζωγράφου, T.K. 15771, ΑΘΗΝΑ <br />
                            <Phone className={classes.communication} /> ΤΗΛΕΦΩΝΟ ΕΠΙΚΟΙΝΩΝΙΑΣ: 2107274598 <br />
                            <Email className={classes.communication} /> <Link href='mailto:skaltsounis@pharm.uoa.gr'>skaltsounis@pharm.uoa.gr</Link> <br />
                            <Language className={classes.communication} /> <Link href='http://www.elke.uoa.gr/'>Ιστοσελίδα</Link>
                        </Typography>
                    </p>
                </React.Fragment>
                : null
            }

            {activeDescription === 2 ?
                <React.Fragment>
                    <p>
                        <Typography variant='h6'>Γενικά στοιχεία</Typography>
                        <Grid container>
                            <Grid item sm={3}>
                                <Link href='http://www.melasoil.gr/'> <img src="/Melas.png" alt="logo" className={classes.smallMelas} /></Link>
                            </Grid>
                            <Grid item sm={9}>
                                <Typography align='left'>
                                    <br />
                                    <br />
                                    <br />
                                    Α/Α ΦΟΡΕΑ: 3 <br />
                            ΣΥΝΤΟΝΙΣΤΗΣ: ΟΧΙ <br />
                            ΕΠΩΝΥΜΙΑ ΦΟΡΕΑ: ΜΕΛΑΣ - Ελαιουργία Επιδαύριας Γης<br />
                            ΣΥΝΤΟΜΟΓΡΑΦΙΑ ΦΟΡΕΑ: ΜΕΛΑΣ<br />
                                </Typography>
                            </Grid>
                        </Grid>
                    </p>
                    <p>
                        <Typography variant='h6'>Συνοπτική παρουσίαση δικαιούχου φορέα</Typography>
                        <Typography align='justify'>
                            Οι ελαιώνες, το ελαιοτριβείο και η μονάδα τυποποίησης της οικογένειας ΜΕΛΑ βρίσκονται συγκεντρωμένα στο Λυγουριό του σημερινού Δήμου Επιδαύρου (τέως Ασκληπιείου) που ανήκει στο Νομό Αργολίδας. Η επιχείρηση ιδρύεται στις 21/11/1994 με την επωνυμία ΕΥΑΓΓΕΛΟΣ Β. ΜΕΛΑΣ με αντικείμενο την τυποποίηση και εμπορία ελαιολάδου. Την ίδια μέρα εγγράφεται και στο Βιοτεχνικό Επιμελητήριο Αργολίδος, με αριθμό μητρώου 15937 (αριθμός δήλωσης έναρξης 3469/21-11-94, ΔΟΥ Ναυπλίου). Σε διάστημα ενός έτους από την ίδρυση της μονάδας και σε 7 μήνες ουσιαστικής λειτουργίας, κατόρθωσε να εξοπλιστεί μηχανολογικά, να οργανωθεί στην αγοραπωλησία ελαιολάδου και να εξάγει στην Ευρώπη – Η.Π.Α. – Καναδά τις πρώτες ποσότητες ελαιολάδου. Αυτή τη στιγμή το Melas Oil εξάγεται σε 26 χώρες, από την Αμερική μέχρι την Ιαπωνία. Παράλληλα, οργανώνει τα υπόλοιπα τμήματα, ώστε να ανταποκριθεί στις αυξανόμενες ανάγκες του αγοραστικού κοινού. Από την αρχή στηρίχτηκε στο πλεονέκτημα της υψηλής ποιότητας και από το 1994 καλλιεργεί με βιολογικές μεθόδους τον ιδιόκτητο ελαιώνα εκτάσεως 50 στρεμμάτων με 750 ελαιόδεντρα. Ήταν η πρώτη βιολογική καλλιέργεια στην περιοχή και μια από τις πρώτες στην Ελλάδα, ενώ πιστοποιήθηκε από την BIO HELLAS το 1998, με αριθμό πιστοποιητικού 360065. Θα πρέπει να τονιστεί ότι η ΜΕΛΑΣ Ελαιουργεία Ασκληπιείου είναι μια από τις λίγες επιχειρήσεις που έχουν το δικαίωμα να κάνουν εξαγωγές ελαιολάδου γιατί πληρούν όλες τις προϋποθέσεις κατά την παραγωγική διαδικασία, τόσο για τις απαιτήσεις της Ευρωπαϊκής Ένωσης, όσο και για τις απαιτήσεις των Τρίτων Χωρών (Κίνα, Η.Π.Α., Καναδάς, Ιαπωνία κλπ). Το 2005 σχεδιάζεται η δημιουργία της υφιστάμενης μονάδας παραγωγής, τυποποίησης και διοίκησης της μονάδας μέσα από την υπαγωγή στον αναπτυξιακό νόμο 1257 διαχείρισης του υπουργείου Αγροτικής Ανάπτυξης και Τροφίμων. Η υλοποίηση της επένδυσης ξεκινά το 2007 μετά την έγκριση του επενδυτικού σχεδίου κι ολοκληρώνεται το 2008. Η νέα μονάδα παραγωγής και τυποποίησης, η οποία αποτελεί υπόδειγμα, σήμερα είναι επισκέψιμη τόσο από φορείς κι επιχειρήσεις του εξωτερικού, με δραστηριότητα στο χώρο του ελαιολάδου, όσο κι από ιδιώτες και ιδρύματα με ενδιαφέρον στην εκμάθηση του κύκλου παραγωγής ελαιολάδου.
                        </Typography>
                    </p>
                    <p>
                        <Typography variant='h6'>Επικοινωνία</Typography>
                        <Typography align='left'>
                            <LocationOn className={classes.communication} /> Χ.& Α. ΣΑΡΡΗ 3 ΑΓ.ΒΛΑΣΣΗΣ, T.K. 21052, ΕΠΙΔΑΥΡΟΣ<br />
                            <Phone className={classes.communication} /> ΤΗΛΕΦΩΝΟ ΕΠΙΚΟΙΝΩΝΙΑΣ: 2753023543 <br />
                            <Email className={classes.communication} /> <Link href='mailto:info@melasoil.gr'>info@melasoil.gr</Link> <br />
                            <Language className={classes.communication} /> <Link href='http://www.melasoil.gr/'>Ιστοσελίδα</Link>
                        </Typography>
                    </p>
                </React.Fragment>
                : null
            }

            {activeDescription === 3 ?
                <React.Fragment>
                    <p>
                        <Typography variant='h6'>Γενικά στοιχεία</Typography>
                        <Typography align='left'>
                            Α/Α ΦΟΡΕΑ: 4 <br />
                            ΣΥΝΤΟΝΙΣΤΗΣ: ΟΧΙ <br />
                            ΕΠΩΝΥΜΙΑ ΦΟΡΕΑ: ΕΘΝΙΚΟ ΚΕΝΤΡΟ ΕΡΕΥΝΑΣ ΦΥΣΙΚΩΝ ΕΠΙΣΤΗΜΩΝ ‘‘ΔΗΜΟΚΡΙΤΟΣ’’<br />
                            ΣΥΝΤΟΜΟΓΡΑΦΙΑ ΦΟΡΕΑ: ΔΗΜΟΚΡΙΤΟΣ<br />
                            ΕΠΩΝΥΜΙΑ ΚΥΡΙΟΥ ΦΟΡΕΑ ΣΤΟΝ ΟΠΟΙΟ ΑΝΗΚΕΙ: ΥΠ. ΠΑΙΔΕΙΑΣ<br />
                        </Typography>
                    </p>
                    <p>
                        <Typography variant='h6'>Συνοπτική παρουσίαση δικαιούχου φορέα</Typography>
                        <Typography align='justify'>
                            Το Εθνικό Κέντρο Έρευνας Φυσικών Επιστημών “ΔΗΜΟΚΡΙΤΟΣ” ιδρύθηκε το
                            1959 ως αποκεντρωμένη δημόσια υπηρεσία. Το Ινστιτούτο Νανοεπιστήμης
                            και Νανοτεχνολογίας (ΙΝΝ) είναι ένα από τα παλαιότερα Ινστιτούτα του
                            ΕΚΕΦΕ &quot;Δημόκριτος&quot;. Στην παρούσα του μορφή διαμορφώθηκε το έτος 2013
                            ως ένα από τα 5 Ινστιτούτα του ΕΚΕΦΕ “Δημόκριτος”. Ο συνδυασμός της
                            πολύ υψηλής ποιότητας του επιστημονικού προσωπικού και της άριστης
                            υποδομής έχει αποφέρει σημαντικές ερευνητικές διακρίσεις και εξωτερική
                            χρηματοδότηση. Η Μονάδα Σταθερών Ισοτόπων και Ραδιοάνθρακα του
                            Ινστιτούτου Νανοεπιστήμης και Νανοτεχνολογίας του ΕΚΕΦΕ “ΔΗΜΟΚΡΙΤΟΣ”
                            έχει κατορθώσει να δημιουργήσει και να αναπτύξει μια τεχνογνωσία υψηλού
                            επιπέδου σε ένα μεγάλο φάσμα ερευνητικών δραστηριοτήτων και υπηρεσιών
                            βασιζόμενη στη χρήση της ισοτοπικής γεωχημείας.
                        </Typography>
                    </p>
                    <p>
                        <Typography variant='h6'>Επικοινωνία</Typography>
                        <Typography align='left'>
                            <LocationOn className={classes.communication} />  ΠΑΤΡΙΑΡΧΟΥ ΙΩΑΚΕΙΜ ΚΑΙ ΝΕΑΠΟΛΕΟΣ, T.K. 15341, ΑΘΗΝΑ<br />
                            <Phone className={classes.communication} /> ΤΗΛΕΦΩΝΟ ΕΠΙΚΟΙΝΩΝΙΑΣ: 2106503002 <br />
                            <Email className={classes.communication} /> <Link href='mailto:communications@central.demokritos.gr'>communications@central.demokritos.gr</Link> <br />
                            <Language className={classes.communication} /> <Link href='http://www.demokritos.gr/el/'>Ιστοσελίδα</Link>
                        </Typography>
                    </p>
                </React.Fragment>
                : null
            }

            {activeDescription === 4 ?
                <React.Fragment>
                    <p>
                        <Typography variant='h6'>Γενικά στοιχεία</Typography>
                        <Typography align='left'>
                            Α/Α ΦΟΡΕΑ: 5 <br />
                            ΣΥΝΤΟΝΙΣΤΗΣ: ΟΧΙ <br />
                            ΕΠΩΝΥΜΙΑ ΦΟΡΕΑ: ΕΘΝΙΚΟ ΚΕΝΤΡΟ ΕΡΕΥΝΑΣ ΚΑΙ ΤΕΧΝΟΛΟΓΙΚΗΣ ΑΝΑΠΤΥΞΗΣ<br />
                            ΣΥΝΤΟΜΟΓΡΑΦΙΑ ΦΟΡΕΑ: ΕΚΕΤΑ<br />
                            ΕΠΩΝΥΜΙΑ ΚΥΡΙΟΥ ΦΟΡΕΑ ΣΤΟΝ ΟΠΟΙΟ ΑΝΗΚΕΙ: ΕΘΝΙΚΟ ΚΕΝΤΡΟ ΕΡΕΥΝΑΣ ΚΑΙ ΤΕΧΝΟΛΟΓΙΚΗΣ ΑΝΑΠΤΥΞΗΣ<br />
                        </Typography>
                    </p>
                    <p>
                        <Typography variant='h6'>Συνοπτική παρουσίαση δικαιούχου φορέα</Typography>
                        <Typography align='justify'>
                            Το Εθνικό Κέντρο Έρευνας και Τεχνολογικής Ανάπτυξης (ΕΚΕΤΑ), ιδρύθηκε
                            το 2000, είναι ένα από τα κορυφαία ερευνητικά κέντρα της Ελλάδας και
                            βρίσκεται μέσα στη λίστα με τους TOP-25 ερευνητικούς και ακαδημαϊκούς
                            φορείς της Ε.Ε. στην προσέλκυση πόρων από ανταγωνιστικά ευρωπαϊκά
                            προγράμματα.
                            Τo Κέντρο είναι Νομικό Πρόσωπο Ιδιωτικού Δικαίου (ΝΠΙΔ) μη
                            κερδοσκοπικού χαρακτήρα που εποπτεύεται από τη Γενική Γραμματεία
                            Έρευνας και Τεχνολογίας (ΓΓΕΤ) του Υπουργείου Παιδείας, Έρευνας και
                            Θρησκευμάτων.
                            Το ΕΚΕΤΑ έχει να επιδείξει σημαντικά επιστημονικά και τεχνολογικά
                            επιτεύγματα σε ερευνητικές περιοχές με μεγάλο ενδιαφέρον για τον
                            άνθρωπο και την κοινωνία όπως: Ενέργεια, Περιβάλλον, Νέα Λειτουργικά
                            Υλικά, Βιομηχανικές Διεργασίες, Πληροφορική, Τηλεματική,
                            Τηλεπικοινωνίες, Μεταφορές, Αγροβιοτεχνολογία, Επιστήμες Υγείας,
                            Μηχανοτρονική, Αγροτεχνολογία καθώς επίσης και σε διάφορες από τα
                            παραπάνω.
                            Στη σημερινή του μορφή το Κέντρο περιλαμβάνει τα ακόλουθα ινστιτούτα:
                            -Ινστιτούτο Χημικών Διεργασιών και Ενεργειακών Πόρων (ΙΔΕΠ) Βιώσιμη και
                            Καθαρή Ενέργεια, Περιβαλλοντικές Τεχνολογίες, Χημικές και Βιοχημικές
                            Διαδικασίες, Προηγμένα Λειτουργικά Υλικά

                            -Ινστιτούτο Τεχνολογιών Πληροφορικής και Επικοινωνιών (ΙΠΤΗΛ)
                            Πληροφορική, Τηλεματική και Τηλεπικοινωνίες
                            -Ινστιτούτο Βιώσιμης Κινητικότητας και Δικτύων Μεταφορών (ΙΜΕΤ) Βιώσιμη
                            Κινητικότητα και Συνδυασμένες Μεταφορές
                            -Ινστιτούτο Εφαρμοσμένων Βιοεπιστημών (ΙΝΕΒ) Αγροβιοτεχνολογία,
                            Μεταφραστική Ιατρική Έρευνα, Πληροφορική Βιοδεδομένων Μεγάλης
                            Κλίμακας
                            -Ινστιτούτο Έρευνας και Τεχνολογίας Θεσσαλίας (ΙΕΤΕΘ) Μηχανοτρονική,
                            Αγροτεχνολογία, Βιοιατρική, Κινησιολογία
                            Στις δραστηριότητες του ΕΚΕΤΑ συμπεριλαμβάνονται τα εξής:
                            -Στο ΕΚΕΤΑ σήμερα εργάζονται περισσότερα από 700 άτομα στην
                            πλειοψηφία τους επιστήμονες.
                            -Έχει λάβει πολλά βραβεία και σημαντικές διακρίσεις όπως το European
                            Descartes Prize, European Research Council (ERC) Advanced Grant,
                            Microsoft International Contest Prize, the Trading Agents Competition Award
                            και πολλά άλλα ενώ κατατάσσεται στα 20 πρώτα Ευρωπαϊκά Ερευνητικά
                            Κέντρα με βάση την υψηλή συμμετοχή του στα χρηματοδοτούμενα
                            προγράμματα του Η2020.
                            -Έχει συμμετάσχει σε περισσότερα από 1.200 ερευνητικά έργα (με συνολικό
                            προϋπολογισμό που ξεπερνάει τα 450 Μ€ και με περισσότερες από 1.100
                            διεθνείς συνεργασίες) χρηματοδοτούμενα από
                            την Ευρωπαϊκή Ένωση, μεγάλες βιομηχανίες του εξωτερικού (Ευρώπη, Ασία
                            και Αμερική) και το Ελληνικό δημόσιο μέσω της Γενικής Γραμματείας
                            Έρευνας και Τεχνολογίας.
                            -Τα ερευνητικά αποτελέσματα του ΕΚΕΤΑ (περισσότερα από 350 άρθρα/έτος)
                            έχουν σημαντική διεθνή επιστημονική απήχηση (περισσότερες από 7.100
                            ετεροαναφορές/έτος)
                            -Οι ερευνητικές δραστηριότητες του Κέντρου έχουν οδηγήσει στη δημιουργία
                            4 εταιρειών τεχνοβλαστών - spin offs.
                            -Το ΕΚΕΤΑ είναι ο πρώτος ελληνικός ερευνητικός φορέας που αναγνωρίζεται
                            από την Ε.Ε. (2012) ότι σέβεται τις αρχές της &quot;Χάρτας του Ερευνητή και του
                            Κώδικα Δεοντολογίας για την πρόσληψη ερευνητών&quot;.
                        </Typography>
                    </p>
                    <p>
                        <Typography variant='h6'>Επικοινωνία</Typography>
                        <Typography align='left'>
                            <LocationOn className={classes.communication} />  ΠΑΤΡΙΑΡΧΟΥ ΙΩΑΚΕΙΜ ΚΑΙ ΝΕΑΠΟΛΕΟΣ, T.K. 15341, ΑΘΗΝΑ<br />
                            <Phone className={classes.communication} /> ΤΗΛΕΦΩΝΟ ΕΠΙΚΟΙΝΩΝΙΑΣ: 2106503002 <br />
                            <Email className={classes.communication} /> <Link href='mailto:communications@central.demokritos.gr'>communications@central.demokritos.gr</Link> <br />
                            <Language className={classes.communication} /> <Link href='http://www.demokritos.gr/el/'>Ιστοσελίδα</Link>
                        </Typography>
                    </p>
                </React.Fragment>
                : null
            }

            {activeDescription === 5 ?
                <React.Fragment>
                    <p>
                        <Typography variant='h6'>Γενικά στοιχεία</Typography>
                        <Typography align='left'>
                            Α/Α ΦΟΡΕΑ: 6 <br />
                            ΣΥΝΤΟΝΙΣΤΗΣ: ΟΧΙ <br />
                            ΕΠΩΝΥΜΙΑ ΦΟΡΕΑ: ΕΡΓΑΣΤΗΡΙΟ ΧΗΜΕΙΑΣ ΤΡΟΦΙΜΩΝ<br />
                            ΣΥΝΤΟΜΟΓΡΑΦΙΑ ΦΟΡΕΑ: ΧΤΤΧΕΚΠΑ<br />
                            ΕΠΩΝΥΜΙΑ ΚΥΡΙΟΥ ΦΟΡΕΑ ΣΤΟΝ ΟΠΟΙΟ ΑΝΗΚΕΙ: ΤΜΗΜΑ ΧΗΜΕΙΑΣ ΤΟΜΕΑΣ 2 ΕΚΠΑ<br />
                        </Typography>
                    </p>
                    <p>
                        <Typography variant='h6'>Συνοπτική παρουσίαση δικαιούχου φορέα</Typography>
                        <Typography align='justify'>
                            Το ΕΚΠΑ είναι ΝΠΔΔ. Το τμήμα Χημείας ανήκει στο ΕΚΠΑ και το εργαστήριο χημείας τροφίμων ανήκει στον τομέα ΙΙ του τμήματος Χημείας. Το 1922 το Τμήμα Χημείας του ΕΚΠΑ απέκτησε την Έδρα της Χημείας Τροφίμων και είναι από τα πρώτα τμήματα της Χημείας Τροφίμων στην Ελλάδα. Σήμερα το εργαστήριο δραστηριοποιείται σε διάφορα ερευνητικά προγράμματα, παρέχει εξειδικευμένες υπηρεσίες στην ανάλυση τροφίμων τόσο σε δημόσιους φορείς όσο και σε επιχειρήσεις και απαρτίζεται από τρία μέλη ΔΕΠ. Οι κύριες ερευνητικές του δραστηριότητες είναι:
                            <ul>
                                <li>Ποιοτικός και ποσοτικός προσδιορισμός βιοδραστικών συστατικών (πολυφαινόλες, βιταμίνες, καροτενοειδή) τροφίμων (π.χ. αφεψημάτων, οίνων, ζύθων, φυτικά προϊόντα) και αιθερίων ελαίων και μελέτη της αντιοξειδωτικής τους ικανότητας.</ li>
                                <li>Μελέτη των επιπέδων βαρέων μετάλλων (όπως Cd, Pb, Hg, As) σε τρόφιμα Ελληνικής προέλευσης (Φυτικά και Ζωϊκά) και σε μεταποιημένα τρόφιμα (π.χ. κονσερβοποιημένα) καθώς και μετανάστευση τους απο τη συσκευασία στο τρόφιμο.</ li>
                                <li>Μελέτη των παραγόντων που επηρεάζουν την βιοσύνθεση των τοξικών μεταβολιτών των μυκήτων σε αγροτικά προιόντα</ li>
                                <li>Ανάπτυξη και επικύρωση μεθόδων προσδιορισμού μυκοτοξινών στα τρόφιμα.</ li>
                                <li>Ποιοτικός και ποσοτικός προσδιορισμός των λιπιδίων υδρόβιων βρώσιμων οργανισμών (ψαριών και θαλασσινών) [κυρίως των πολυακόρεστων λιπαρών οξέων (EPA, DHA), στερολών, τριγλυκεριδίων, των φωσφολιπιδίων, καροτενοειδών], καθώς και των απαραίτητων μετάλλων για την εκτίμηση της διατροφικής τους αξίας.</ li>
                                <li>Αναλύσεις ποιοτικού ελέγχου γάλακτος, κρέατος, φυτικών προϊόντων (λίπος, πρωτεϊνες, υγρασία, τέφρα, διαιτητικές ίνες).</ li>
                            </ul>
                            Είναι εξοπλισμένο με κατάλληλα επιστημονικά αναλυτικά όργανα για τις αναλύσεις που αναφέρονται στα ΠΕ που συμμετέχει όπως Αέριοχρωματογάφο με ανιχνευτή φλόγας, υγροχρωματογράφο με ανιχνευτή υπεριώδους ορατού, φασματοφωτόμετρα, απλά και ατομικής απορρόφησης με φλόγα, καθώς και άλλες αναλυτικές συσκευές  προσδιορισμού πρωτεϊνών, λίπους, υγρασίας, τέφρας κ.α., Διαθέτει επίσης πλήρως εξοπλισμένο εργαστήριο για μικροβιολογικές αναλύσεις και αναλύσεις τοξινών. Τέλος έχει κατάλληλους χώρους για μελέτη οργανοληπτικών χαρακτηριστικών τροφίμων και ποτών.
                        </Typography>
                    </p>
                    <p>
                        <Typography variant='h6'>Επικοινωνία</Typography>
                        <Typography align='left'>
                            <LocationOn className={classes.communication} />ΠΑΝΕΠΙΣΤΗΜΙΟΥΠΟΛΗ ΖΩΓΡΑΦΟΥ, T.K. 15771, ΑΘΗΝΑ<br />
                            <Phone className={classes.communication} /> ΤΗΛΕΦΩΝΟ ΕΠΙΚΟΙΝΩΝΙΑΣ: 2107274160<br />
                            <Email className={classes.communication} /> <Link href='mailto:harpro@chem.uoa.gr'>harpro@chem.uoa.gr</Link> <br />
                            <Language className={classes.communication} /> <Link href='http://www.elke.uoa.gr/'>Ιστοσελίδα</Link>
                        </Typography>
                    </p>
                </React.Fragment>
                : null
            }


            {activeDescription === 6 ?
                <React.Fragment>
                    <p>
                        <Typography variant='h6'>Γενικά στοιχεία</Typography>
                        <Typography align='left'>
                            Α/Α ΦΟΡΕΑ: 7 <br />
                            ΣΥΝΤΟΝΙΣΤΗΣ: ΟΧΙ <br />
                            ΕΠΩΝΥΜΙΑ ΦΟΡΕΑ: ΓΕΩΠΟΝΙΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ-ΕΡΓΑΣΤΗΡΙΟ ΓΑΛΑΚΤΟΚΟΜΙΑΣ <br />
                            ΣΥΝΤΟΜΟΓΡΑΦΙΑ ΦΟΡΕΑ: ΓΠΑ<br />
                            ΕΠΩΝΥΜΙΑ ΚΥΡΙΟΥ ΦΟΡΕΑ ΣΤΟΝ ΟΠΟΙΟ ΑΝΗΚΕΙ: ΓΕΩΠΟΝΙΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ<br />
                        </Typography>
                    </p>
                    <p>
                        <Typography variant='h6'>Συνοπτική παρουσίαση δικαιούχου φορέα</Typography>
                        <Typography align='justify'>
                            Το Εργαστήριο Γαλακτοκομίας ανήκει στο Τμήμα Επιστήμης Τροφίμων και
                            Διατροφής του Ανθρώπου της Σχολής Τροφίμων, Βιοτεχνολογίας και
                            Ανάπτυξης του Γεωπονικού Πανεπιστημίου Αθηνών (ΓΠΑ). Λειτουργεί ως
                            αυτοτελής εκπαιδευτική και ερευνητική μονάδα από το 1962. Έχει την
                            ευθύνη της εκπαίδευσης προπτυχιακών και μεταπτυχιακών φοιτητών,
                            κυρίως του Τμήματος Επιστήμης Τροφίμων και Διατροφής του Ανθρώπου
                            αλλά και άλλων τμημάτων του ΓΠΑ, σε θέματα Επιστήμης και Τεχνολογίας
                            Γάλακτος και Γαλακτοκομικών Προϊόντων, όπως επίσης και Βιοχημείας
                            Τροφίμων. Το Εργαστήριο Γαλακτοκομίας διαθέτει μόνιμο ειδικευμένο
                            επιστημονικό και τεχνικό προσωπικό, πλήρως ανακαινισμένη κτιριακή
                            υποδομή (1.200 τ.μ.) καθώς και σύγχρονο επιστημονικό και τεχνολογικό
                            εξοπλισμό. Περιλαμβάνει άνετους εργαστηριακούς χώρους, τόσο
                            εκπαιδευτικούς όσο και ερευνητικούς, καθώς επίσης και πιλοτικό
                            τυροκομείο με θαλάμους ωρίμανσης και συντήρησης τυριών. Ο
                            επιστημονικός εξοπλισμός του Εργαστηρίου περιλαμβάνει όλα τα μικρά και
                            μεγάλα όργανα ενός σύγχρονου εργαστηρίου Χημείας και Μικροβιολογίας
                            Γάλακτος καθώς επίσης Βιοχημείας και Μοριακής Βιολογίας.
                        </Typography>
                    </p>
                    <p>
                        <Typography variant='h6'>Επικοινωνία</Typography>
                        <Typography align='left'>
                            <LocationOn className={classes.communication} />ΙΕΡΑ ΟΔΟΣ 75 , T.K. 11855, ΑΘΗΝΑ<br />
                            <Phone className={classes.communication} /> ΤΗΛΕΦΩΝΟ ΕΠΙΚΟΙΝΩΝΙΑΣ: 2105204661<br />
                            <Email className={classes.communication} /> <Link href='mailto:et@aua.gr'>et@aua.gr</Link> <br />
                            <Language className={classes.communication} /> <Link href='https://www2.aua.gr/el'>Ιστοσελίδα</Link>
                        </Typography>
                    </p>
                </React.Fragment>
                : null
            }
        </React.Fragment>
    )
}